import { useCallback } from 'react';
import { endGameSession } from '@sorrem-client/game/game-session-store';
import { useAppNavigate } from '@sorrem-client/ui/hooks';

/** Where a player goes on leaving a run: Character Home, or the Crucibles list (after quitting, or losing the connection). */
const RUN_EXIT_PATHS = {
    home: '/character/overview',
    crucibles: '/character/crucibles',
} as const;

export type RunExit = keyof typeof RUN_EXIT_PATHS;

/**
 * Leaves the run for \`exit\`: waits for the game to stop first, so its leave
 * reaches the host instead of being cut off by the page load.
 */
export function useLeaveRun(): (exit: RunExit, options?: { replace?: boolean }) => Promise<void> {
    const navigate = useAppNavigate();
    return useCallback(async (exit: RunExit, options?: { replace?: boolean }): Promise<void> => {
        await endGameSession();
        navigate(RUN_EXIT_PATHS[exit], options);
    }, [navigate]);
}
